import React, { useRef } from 'react';
import styles from './accordion.module.css';
import { AnyIfEmpty } from 'react-redux';
import UpArrowIcon from '../svgIcons/UpArrowIcon';
import ChevronIcon from '../svgIcons/ChevronIcon';

interface AccordionProps {
    title: string;
    content: any;
    active: boolean;
    onToggle: (index: number) => void;
    index: number;
}

const Accordion = ({ title, content, active, onToggle, index }: AccordionProps) => {
    const contentEl: AnyIfEmpty<object> = useRef();
    return (
        <div className={styles.questionnarieContent}>
            <button className={`${styles.accordion} ${active ? styles.active : ''}`} onClick={() => onToggle(index)}>
                <p className={styles.accordion__title}>{title}</p>
                <div className={`${styles.chevronIcon} ${active ? styles.active : ''}`}>
                    <ChevronIcon />
                </div>
            </button>
            <div
                ref={contentEl}
                style={{ maxHeight: `${active ? `${contentEl.current?.scrollHeight}px` : '0px'}` }}
                className={styles.accordionContent}>
                <div>{content}</div>
            </div>
        </div>
    );
};

export default Accordion;
